import { CONFIG } from "constants/index";

export const configWithGeneralLabel = [
    CONFIG.UPTIME_APIM_SERVICES,
    CONFIG.UPTIME_APPLICATION_INSIGHTS,
    CONFIG.UPTIME_HOMEPAGE,
    CONFIG.UPTIME_TEAMS_APP,
    CONFIG.UPTIME_PERFORMANCE,
    CONFIG.UPTIME_LANGUAGE,
    CONFIG.UPTIME_FOOTER,
    CONFIG.UPTIME_QUALTRICS,
    CONFIG.UPTIME_ATTACHMENTS,
    CONFIG.UPTIME_IMAGE,
    CONFIG.UPTIME_KNOWLEDGE,
    CONFIG.UPTIME_TOOLTIP,
    CONFIG.UPTIME_CHAT_WIDGET,
    CONFIG.UPTIME_PCL_SETTING,
    CONFIG.UPTIME_GENERAL,
    CONFIG.UPTIME_HARDWARE_MANAGEMENT,
    CONFIG.UPTIME_GLOBAL_SEARCH_SETTING
];

export const configWithStaticPageLabel = [
    CONFIG.UPTIME_STATIC_LANDING_PAGE,
    CONFIG.PILOT_CONFIG.CONTENT,
    CONFIG.OUTAGE_CONTENT
];